import moment from 'moment';
import { mapObjIndexed, equals, cond, is, T, identity, either, anyPass, map } from 'ramda';

export const formatDatesAndPrices = mapObjIndexed((property: any, key: string) =>
  cond([
    [
      () => either(equals('checkIn'), equals('checkOut'))(key),
      (p) => moment(p).format('DD-MM-YYYY'),
    ],
    [() => anyPass([equals('amount'), equals('revenue')])(key), (p) => p / 100],
    [is(Array), map(formatDatesAndPrices)],
    [is(Object), formatDatesAndPrices],
    [T, identity],
  ])(property)
);

const parseProduct = (product) => ({
  quantity: product.quantity,
  category: product.type,
  price: product.price.amount,
  ...(product.option && { variant: product.option.name }),
  ...(product.product && { name: product.product.name, id: product.product.id }),
  ...(product.bookable && {
    variant: product.bookable.rate,
    name: product.bookable.name,
    id: product.bookable.id,
  }),
  ...(product.type === 'rooms' && {
    quantity: moment(product.checkOut, 'DD-MM-YYYY').diff(
      moment(product.checkIn, 'DD-MM-YYYY'),
      'days'
    ),
  }),
  ...(product.type === 'tables' && { variant: product.bookable.ids.restaurant }),
});

export const generateAnalyticsOrder = ({
  orderReference,
  taxTotal,
  deliveryCost,
  items,
  total,
  property,
}) => ({
  purchase: {
    actionField: {
      id: orderReference,
      revenue: total?.amount,
      tax: taxTotal?.amount || 0,
      shipping: deliveryCost ? deliveryCost.amount : 0,
      brand: property?.name,
    },
    products: items.map((item) => parseProduct(item)),
  },
});
